import { api } from '@/redux/api/api';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { updatePropertyRecipe } from '@/redux/utils/update-property-recipe';
import { Policy } from '@/types/policy';
import { UpdateWellbeingCheckSettingsQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchUpdateWellbeingCheckSettings: DispatchOptimisticPatchHandler<
  UpdateWellbeingCheckSettingsQueryArg
> = ({ organisation, wellbeingCheckSettings }, { dispatch }) => {
  const patch = dispatch(
    api.util.updateQueryData(
      'getPolicies',
      { organisation },
      updatePropertyRecipe<Policy, 'wellbeingCheckSettings'>(
        'wellbeingCheckSettings',
        wellbeingCheckSettings,
      ),
    ),
  );

  return { patch };
};
